// ============================================================
// VERSIÓN DE PRUEBA: todo el contenido del Home está comentado.
// Para restaurarlo, selecciona todo y usa "Uncomment" (Cmd+/)
// ============================================================

// import React, { useState, useEffect } from "react";
//
// import UserService from "../services/user.service";
// import { Container, Row, Col } from "react-bootstrap/";
//
// import {
//   Eye,
//   Star,
//   Flower2,
//   Heart,
//   ShieldCheck,
//   People,
//   Award,
//   Globe,
//   Stars,
// } from "react-bootstrap-icons";
//
// import wsp from "../assets/wsp.png";
//
// import "./Home.css";
//
// const valores = [
//   {
//     icono: <Flower2 />,
//     titulo: "Humildad",
//     texto:
//       "Reconociendo nuestros defectos para mejorarlos y al mismo tiempo conocemos cuáles son nuestras virtudes para llevarlas a su máxima expresión.",
//   },
//   {
//     icono: <Heart />,
//     titulo: "Pasión",
//     texto:
//       "Comprometiéndonos con nuestras fuerzas, el corazón, el alma y la mente en todo lo que emprendamos.",
//   },
//   {
//     icono: <ShieldCheck />,
//     titulo: "Integridad",
//     texto:
//       "Siendo muy transparentes con nuestro personal, proveedores y clientes.",
//   },
//   {
//     icono: <People />,
//     titulo: "Colaboración",
//     texto:
//       "Incentivando el trabajo en equipo para poder crear un esfuerzo sinérgico.",
//   },
//   {
//     icono: <Award />,
//     titulo: "Compromiso",
//     texto:
//       "Brindando nuestros servicios y ofreciendo nuestra ayuda tanto al momento de generar la venta como en el post-venta.",
//   },
//   {
//     icono: <Globe />,
//     titulo: "Coherencia",
//     texto: "Entre nuestros valores y nuestros objetivos.",
//   },
//   {
//     icono: <ShieldCheck />,
//     titulo: "Confianza",
//     texto:
//       "Evitando defraudar a nuestros clientes, proveedores y personal, considerando que la base de una relación en el tiempo es la confianza mutua.",
//   },
//   {
//     icono: <Stars />,
//     titulo: "Calidad",
//     texto: "Buscando en todo momento la excelencia.",
//   },
// ];

const Home = () => {
  // const [content, setContent] = useState("");
  //
  // useEffect(() => {
  //   UserService.getPublicContent().then(
  //     (response) => {
  //       setContent(response.data);
  //     },
  //     (error) => {
  //       const _content =
  //         (error.response && error.response.data) ||
  //         error.message ||
  //         error.toString();
  //
  //       setContent(_content);
  //     }
  //   );
  // }, []);

  // return (
  //
  //   <div className="home">
  //     {/* Hero */}
  //     <section className="hero">
  //       <video
  //         className="hero__video"
  //         autoPlay
  //         muted
  //         loop
  //         playsInline
  //         poster="/videos/hero-poster.jpg"
  //       >
  //         <source src="/videos/hero-video.webm" type="video/webm" />
  //         <source src="/videos/hero-video.mp4" type="video/mp4" />
  //       </video>
  //       <div className="hero__overlay" />
  //     </section>
  //
  //     {/* ¿Quiénes somos? */}
  //     <section className="about">
  //       <Container>
  //         <h2 className="section-title">¿Quiénes somos?</h2>
  //         <div className="section-divider" />
  //         <p className="about__text">
  //           Somos una empresa con una trayectoria sólida en el rubro mayorista
  //           de Librería, Mercería y Juguetería. Nos motiva la constante
  //           preocupación por nuestros clientes, ofreciendo junto con nuestro
  //           personal una atención profesional, eficaz y cordial. Nuestra
  //           experiencia en el mercado nos permite brindar seguridad y
  //           satisfacción a toda nuestra clientela.
  //         </p>
  //       </Container>
  //     </section>
  //
  //     {/* Misión / Visión */}
  //     <section className="mv">
  //       <div className="mv__container">
  //         <Container>
  //         <Row className="g-0">
  //           <Col md={6} className="mv-col">
  //             <div className="mv__card">
  //               <div className="mv__icon">
  //                 <Eye />
  //               </div>
  //               <h3>Nuestra Misión</h3>
  //               <p>
  //                 Somos una empresa que demuestra una constante preocupación por
  //                 sus clientes, ofreciendo junto con nuestro personal, una
  //                 atención profesional, eficaz, cordial y con una gran
  //                 experiencia en el mercado, brindando así una alta seguridad y
  //                 satisfacción a nuestra clientela.
  //               </p>
  //             </div>
  //           </Col>
  //           <Col md={6} className="mv-col">
  //             <div className="mv__card">
  //               <div className="mv__icon">
  //                 <Star />
  //               </div>
  //               <h3>Nuestra Visión</h3>
  //               <p>
  //                 Ser los líderes en el rubro mayorista de Librería, Mercería y
  //                 Juguetería siendo reconocidos como la empresa de mayor
  //                 trayectoria y confiabilidad del mercado. Y así, con una
  //                 constante preocupación por nuestros clientes, poderles brindar
  //                 el apoyo, asesoramiento y respaldo que estos nos soliciten.
  //               </p>
  //             </div>
  //           </Col>
  //         </Row>
  //         </Container>
  //       </div>
  //     </section>
  //
  //     {/* Valores */}
  //     <section className="valores">
  //       <Container>
  //         <h2 className="section-title">Nuestros Valores</h2>
  //         <div className="section-divider" />
  //         <p className="section-subtitle">
  //           Los pilares que guían nuestro trabajo diario
  //         </p>
  //         <Row className="g-0">
  //           {valores.map((valor, idx) => (
  //             <Col key={idx} xs={12} sm={6} lg={3} className="valor-col">
  //               <div className="valor__item">
  //                 <div className="valor__icon">{valor.icono}</div>
  //                 <strong>{valor.titulo}</strong>
  //                 <span>{valor.texto}</span>
  //               </div>
  //             </Col>
  //           ))}
  //         </Row>
  //       </Container>
  //     </section>
  //
  //     {/* Horario */}
  //     <section className="horario">
  //       <div className="horario__banner">
  //         <Container>
  //           <h4>
  //             Nuestra atención y venta Mayorista es de 11:30 a 15:30 hs de Lunes a
  //             Viernes.
  //             <br />
  //             NO CONTAMOS CON VENTA MINORISTA.
  //             <br />
  //             Para más información o consultas, pónganse en contacto con
  //             nosotros.
  //           </h4>
  //         </Container>
  //       </div>
  //     </section>
  //
  //     {/* Mapa + Contacto */}
  //     <section className="mapa-contacto">
  //       <div className="mapa-contacto__container">
  //         <Container>
  //           <h2 className="section-title">Contacto</h2>
  //           <div className="section-divider" />
  //           <p className="section-subtitle">Encontranos o escribinos</p>
  //           <Row className="g-4 align-items-stretch">
  //             <Col lg={8}>
  //               <iframe
  //                 className="mapa__frame"
  //                 title="Ubicación José Karam e Hijos"
  //                 src="https://maps-api-ssl.google.com/maps?hl=es-419&ll=-31.530611,-68.521914&output=embed&q=Av.+Rioja+Norte+360,+J5400+EMQ,+San+Juan,+Argentina+(Karam+Jos%C3%A9+e+Hijos+Mercer%C3%ADa+y+Librer%C3%ADa)&z=16"
  //                 allowFullScreen
  //               />
  //             </Col>
  //             <Col lg={4}>
  //               <a
  //                 href="https://wa.me/5492644605714?text=Hola, quisiera hacer una consulta."
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //                 className="wsp__card"
  //               >
  //                 <img
  //                   src={wsp}
  //                   alt="WhatsApp"
  //                 />
  //                 <p>Contáctese con nosotros por WhatsApp</p>
  //                 <p>José Karam e Hijos</p>
  //               </a>
  //             </Col>
  //           </Row>
  //         </Container>
  //       </div>
  //     </section>
  //
  //     {/* Ubicación */}
  //     <section className="ubicacion">
  //       <Container>
  //         <p>
  //           Nos encontramos en Av. Rioja, 360 (Norte) entre Calles Maipú y
  //           Pedro Echagüe — San Juan, Argentina.
  //         </p>
  //       </Container>
  //     </section>
  //   </div>
  // );

  // Home en versión de prueba: no se renderiza contenido
  return null;
};

export default Home;
